<template>
  <div style="display: flex">
    <Select v-if="timeModel1.length>1" v-model="chaxunmodel" @on-change="changeModel" style="width: 70px">
      <Option :value="0" v-if="timeModel1.includes(0)">自选</Option>
      <Option :value="1" v-if="timeModel1.includes(1)">按天</Option>
      <Option :value="2" v-if="timeModel1.includes(2)">按月</Option>
      <Option :value="3" v-if="timeModel1.includes(3)">季度</Option>
      <Option :value="4" v-if="timeModel1.includes(4)">按年</Option>
    </Select>
    <template v-if="chaxunmodel == 0">
      <Select v-model="day" @on-change="selectGetDay" style="width: 80px">
        <Option v-for="item in dayList" :value="item.value" :key="item.value">{{
          item.label
        }}</Option>
      </Select>
      <DatePicker
        :type="datetime ? 'datetime' : 'date'"
        :style="{ width: (datetime ? 170 : 116) + 'px' }"
        v-model="startTime"
        :clearable="false"
      ></DatePicker>
      <span style="margin: 4px 4px 0 4px">至</span>
      <DatePicker
        :type="datetime ? 'datetime' : 'date'"
        :style="{ width: (datetime ? 170 : 116) + 'px' }"
        v-model="endTime"
        @on-change="endChange"
        :clearable="false"
      ></DatePicker>
    </template>
    <template v-if="chaxunmodel == 3">
      <DatePicker
        type="year"
        v-model="year"
        style="width: 80px"
        :clearable="false"
      ></DatePicker>
      <Select v-model="jidu" style="width: 80px">
        <Option :value="0">一季度</Option>
        <Option :value="1">二季度</Option>
        <Option :value="2">三季度</Option>
        <Option :value="3">四季度</Option>
      </Select>
    </template>
    <template v-if="chaxunmodel == 2">
      <DatePicker
        type="month"
        v-model="month"
        style="width: 100px"
        :clearable="false"
      ></DatePicker>
    </template>
    <template v-if="chaxunmodel == 1">
      <DatePicker
        type="date"
        v-model="date"
        style="width: 140px"
        :clearable="false"
      ></DatePicker>
    </template>
    <template v-if="chaxunmodel == 4">
      <DatePicker
        type="year"
        v-model="year"
        style="width: 100px"
        :clearable="false"
      ></DatePicker>
    </template>
  </div>
</template>
<script>
export default {
  props: ["day0", "timeModel", "datetime","addDay"],
  data() {
    return {
      timeModel1: this.timeModel || "0,1,2",
      chaxunmodel: this.timeModel == undefined ? 0 : Number(this.timeModel[0]),
      year: new Date(),
      jidu: parseInt(new Date().getMonth() / 3),
      month: new Date(),
      date: new Date(Date.now() + (this.addDay ? this.addDay : 0)),
      dayList: [
        {
          value: -3,
          label: "近三天",
        },
        {
          value: -7,
          label: "近七天",
        },
        {
          value: -15,
          label: "近15天",
        },
        {
          value: -30,
          label: "近30天",
        },
        {
          value: 10,
          label: "自定义",
        },
      ],
      day: this.day0 || -7,
      startTime: "",
      endTime: "",
    };
  },
  methods: {
    selectGetDay() {
      var t = this.utils.days(this.day, 0);
      this.startTime = new Date(t.start);
      this.endTime = new Date(t.end);
      this.timeObj = {
        start: this.startTime.getTime(),
        end: this.endTime.getTime(),
      };
    },
    //自由查询
    ziyou() {
      if (
        this.utils.jcTime(this, {
          startTime: this.startTime,
          endTime: this.endTime,
        })
      ) {
        this.timeObj = {
          start: this.startTime.getTime(),
          end: this.endTime.getTime(),
        };
      }
    },
    chajidu() {
      var y = this.year.getFullYear();
      var start = new Date(y, this.jidu * 3, 1).getTime();
      var end = new Date(y, this.jidu * 3 + 3, 1).getTime() - 1000;
      this.timeObj = { start, end };
    },
    searchMonth() {
      var y = this.month.getFullYear();
      var m = this.month.getMonth();
      var start = new Date(y, m, 1).getTime();
      var end = new Date(y, m + 1, 1).getTime() - 1000;
      this.timeObj = { start, end };
    },
    searchDay() {
      var y = this.date.getFullYear();
      var m = this.date.getMonth();
      var d = this.date.getDate();
      var start = new Date(y, m, d).getTime();
      var end = new Date(y, m, d + 1).getTime() - 1000;
      console.log(Date.now());
      this.timeObj = { start, end };
    },
    searchYear() {
      var y = this.month.getFullYear();
      var start = new Date(y, 0, 1).getTime();
      var end = new Date(y + 1, 0, 1).getTime() - 1000;
      this.timeObj = { start, end };
    },
    //手动选择结束时间的时候，默认加到当前时间时分秒
    endChange() {
      this.endTime = new Date(this.endTime.getTime() + 86399 * 1000);
      this.endTime;
    },
    //模式转换
    changeModel(v) {
      if (v == 0) {
        this.selectGetDay(this.day);
      }
    },
    getTimeObj() {
      var m = this.chaxunmodel;
      if (m == 0) {
        this.ziyou();
      } else if (m == 1) {
        this.searchDay();
      } else if (m == 2) {
        this.searchMonth();
      } else if (m == 3) {
        this.chajidu();
      } else if (m == 4) {
        this.searchYear();
      }
      return this.timeObj;
    },
  },
  mounted() {
    if (this.timeModel1[0] == "0") {
      this.selectGetDay(this.day);
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/common/startEnd.vue